module.exports = __webpack_public_path__ + "static/media/nu_logo.a1ee4f24.png";